import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Select: ComponentStyleConfig = {
  baseStyle: {
    field: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
    },
    icon: {
      marginTop: '-10px',
      right: '-10px',
    },
  },
  defaultProps: {
    variant: 'unstyled',
  },
};
